(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["email-capture"] && !Shopify.designMode) return;
  try {
    (function () {
    var el = document.querySelector('[data-email-capture]');
    if (!el || typeof el.showModal !== 'function') return;

    var SEEN = 'leonly:capture:dismissed';
    var DONE = 'leonly:capture:subscribed';
    var store = {
      get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
    };

    if (el.querySelector('[data-capture-success]')) {
      store.set(DONE, '1');
      try { el.showModal(); } catch (e) {}
      return;
    }

    if (store.get(DONE)) return;

    var dismissedAt = parseInt(store.get(SEEN) || '0', 10);
    var cooldownDays = parseInt(el.dataset.cooldown || '30', 10);
    if (dismissedAt && Date.now() - dismissedAt < cooldownDays * 864e5) return;

    var opened = false;
    function open() {
      if (opened || el.open) return;
      opened = true;
      cleanup();
      try { el.showModal(); } catch (e) { return; }
      var input = el.querySelector('.capture__input');
      // Do not steal the on-screen keyboard on touch devices.
      if (input && window.matchMedia('(min-width: 750px)').matches) input.focus();
    }

    var timer = window.setTimeout(open, (parseFloat(el.dataset.delay) || 8) * 1000);

    function onScroll() {
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      if (max <= 0) return;
      if ((window.scrollY / max) * 100 >= (parseFloat(el.dataset.scroll) || 35)) open();
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    function cleanup() {
      window.clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
    }

    el.addEventListener('close', function () { store.set(SEEN, String(Date.now())); });
    el.addEventListener('click', function (e) {
      // Click on the backdrop closes it.
      if (e.target === el) el.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
